<nb-card>
  <nb-card-header>
    <div class="menu-buttons"></div>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <div id="print-section" class="print-layout">
      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td style="text-align: center">
            <h4>{{ shop.title }}</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              {{ shop.address }}
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              ĐT: {{ shop.mobile }}
              <span *ngIf="shop.email"> - Email: {{ shop.email }} </span>
              <span *ngIf="shop.website"> - Web: {{ shop.website }} </span>
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <h4>NHẬT KÝ CÔNG VIỆC</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              Ngày:
              {{ task.issueDate | date : "dd/MM/yyyy " }}
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label> *** </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>
      </table>

      <table class="table-header">
        <tr>
          <td>
            <b>I. Thông tin chung</b>
            <table class="table-detail">
              <tr>
                <td style="width: 60%">Khách hàng</td>
                <td style="width: 40%">Người phụ trách</td>
              </tr>
              <tr>
                <td>
                  <ul>
                    <li>
                      <span *ngIf="customer && customer.fullName">
                        Tên: {{ customer.fullName }}
                      </span>
                      <span
                        *ngIf="!customer || !customer.fullName"
                        class="dotted-line"
                      >
                        Tên:
                      </span>
                    </li>

                    <li>
                      <span *ngIf="customer && customer.mobile">
                        Điện thoại: {{ customer.mobile }}
                      </span>
                      <span
                        *ngIf="!customer || !customer.mobile"
                        class="dotted-line"
                      >
                        Điện thoại:
                      </span>
                    </li>
                    <li>
                      <span *ngIf="customer && customer.address">
                        Địa chỉ:{{ customer.address }}
                      </span>
                      <span
                        *ngIf="!customer || !customer.address"
                        class="dotted-line"
                      >
                        Địa chỉ:
                      </span>
                    </li>
                  </ul>
                </td>
                <td>
                  <ul *ngIf="task.processors && task.processors.length > 0">
                    <li *ngFor="let nv of task.processors; let i = index">
                      {{ nv.employee.fullName }}
                    </li>
                    <li>
                      <ng-container *ngIf="3 - task.processors.length > 0">
                        <ng-template
                          [ngTemplateOutlet]="emptyLine"
                          [ngTemplateOutletContext]="{
                            lines: 3 - task.processors.length
                          }"
                        >
                        </ng-template>
                      </ng-container>
                    </li>
                  </ul>

                  <ul *ngIf="!task.processors || task.processors.length == 0">
                    <li><span class="dotted-line"> </span></li>
                    <li><span class="dotted-line"> </span></li>
                    <li><span class="dotted-line"> </span></li>
                  </ul>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <b>II. Nội dung công việc</b>
            <table class="table-header">
              <tr>
                <td class="dotted-fill">
                  {{ task.title }}
                  <ng-container *ngIf="remainingLines > 0">
                    <ng-template
                      [ngTemplateOutlet]="emptyLine"
                      [ngTemplateOutletContext]="{ lines: remainingLines }"
                    >
                    </ng-template>
                  </ng-container>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <b
              >III. Kết quả công việc
              <span class="text-hint">(* Chụp hình ảnh gửi Zalo )</span></b
            >
            <table class="table-detail">
              <tr>
                <td style="width: 40%">Hoàn thành</td>
                <td style="width: 35%">Chưa hoàn thành</td>
                <td style="width: 25%">Hẹn lại</td>
              </tr>

              <tr>
                <td>
                  <ng-template
                    [ngTemplateOutlet]="emptyLine"
                    [ngTemplateOutletContext]="{ lines: 8 }"
                  ></ng-template>
                </td>
                <td>
                  <ng-template
                    [ngTemplateOutlet]="emptyLine"
                    [ngTemplateOutletContext]="{ lines: 8 }"
                  ></ng-template>
                </td>
                <td>
                  <ng-template
                    [ngTemplateOutlet]="emptyLine"
                    [ngTemplateOutletContext]="{ lines: 8 }"
                  ></ng-template>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <b>IV. Đánh giá, nhận xét của khách hàng ( ký và xác nhận )</b>
            <table class="table-header">
              <tr>
                <ng-template
                  [ngTemplateOutlet]="emptyLine"
                  [ngTemplateOutletContext]="{ lines: 5 }"
                ></ng-template>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <!--- This is hidden using CSS ----->
    <button
      type="button"
      class="btn btn-sm d-none"
      ngxPrint
      printSectionId="print-section"
      styleSheetFile="assets/css/layout-print.css"
      #printBtn
      ngxPrint
    >
      Auto Print
    </button>

    <button
      *ngIf="!printing"
      nbButton
      hero
      shape="semi-round"
      status="info"
      size="medium"
      (click)="print()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
      id="btnPrint"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      {{ "buttons.print" | translate }}
    </button>
  </nb-card-footer>
</nb-card>

<ng-template #emptyLine let-lines="lines">
  <span class="dotted-line" *ngFor="let sp of [].constructor(lines)"></span>
</ng-template>
